<div class="bulk-upload-result-container col full-height">
  <div class="header flex">
    <span class="title">Order File Upload Failed</span>
  </div>
  <div class="bulk-upload-result-content col">
    <div class="row-1 full-width">
      <div class="error-validation">
        Issues were found in the uploaded file. Please download the file and fix the errors marked in red by referring to the
        error notes added to the cells.
      </div>
    </div>
  </div>
  <div class="fill-space"></div>
  <div class="footer flex ai-c">
    <button mat-button class="download ml-10" (click)="downloadFile()">
      Download File 
    </button>
    <button mat-button class="cancel ml-10" (click)="cancel()">
      Cancel
    </button>
  </div>
</div>